import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Button, Row, Col, FormGroup, Label, Input, Form} from 'reactstrap';
import {TabelaCadastro} from "../components/TabelaCadastro";
import Select from "react-select";
import PerfilStore from "../stores/UsuarioStore";
import {arrayToString, createSelectOptions, listDiferencaByAtribute, stringToArray} from "../../../utils/formatar";
import {getTipoPerfilById, tipoPerfilEnum} from "../../../utils/enums";
import {Validacao} from "../../comum/components/Validacao";
import FontAwesome from 'react-fontawesome';

@inject("store")
@DataWrapper
@observer
export class CadastroUsuario extends Component {
    constructor(props) {
        super(props);
        this.modalStore                      = this.props.store.modalStore;
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        /* Selecionar Controller */
        this.controller                 = new PerfilStore(this.modalStore);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Usuário");

        this.controller.carregarLista();
    }

    removePosicao(value){
        this.controller.removePosicaoValue(value);
    }

    modalForm = (editMode) => {
        const tipoPerfilOptions = createSelectOptions(tipoPerfilEnum, "id", "valor");
        const solicitantesMotUsuarioCacheOptions = createSelectOptions(this.controller.itemSelecionado.solicitantesMotUsuario, "matricula", "nome");
        const empregadoOptions = this.controller.itemSelecionado.solicitantesMotUsuario && this.controller.itemSelecionado.solicitantesMotUsuario.map(empregado => {
            return {value: empregado.matricula, label: empregado.nome + " (" + empregado.matricula + ")", gestor: empregado.gestor};
        });


        return(
            <div>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        {!editMode &&
                            <FormGroup>
                                <Label>Usuário <sup>*</sup></Label>
                                <Select simpleValue value={this.controller.itemSelecionado.login}
                                    onChange={(value) => this.controller.setLogin(value)}
                                    searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                    asyncOptions={(input, callback) => this.controller.filtrarUsuarios(input, callback)} />
                                <Validacao id="usuarioLogin" valor={this.controller.itemSelecionado.login} tipo={["isRequired"]} />
                            </FormGroup>
                        }
                        {editMode &&
                            <FormGroup>
                                <Label>Usuário</Label>
                                <Input type="text" value={this.controller.itemSelecionado.nome} readOnly />
                            </FormGroup>
                        }
                    </Col>
                    <Col>
                        <Label>Perfis</Label>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilAdministrador} onChange={() => this.controller.togglePerfilAdministrador()}/>{' '}
                                <Label>Administrador</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilDcch} onChange={() => this.controller.togglePerfilDCCH()}/>{' '}
                                <Label>DCCH</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilDnc} onChange={() => this.controller.togglePerfilDNC()}/>{' '}
                                <Label>DNC</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilRemuneracao} onChange={() => this.controller.togglePerfilRemuneracao()}/>{' '}
                                <Label>Remuneração</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilRts} onChange={() => this.controller.togglePerfilRTS()}/>{' '}
                                <Label>RTS</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilSolicitanteMot} onChange={() => this.controller.togglePerfilSolicitanteMOT()}/>{' '}
                                <Label>Solicitação de MOT</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    {this.controller.itemSelecionado.perfilSolicitanteMot &&
                        <Col xs={12} md={12} lg={12}>
                            <FormGroup>
                                <Label>Pode solicitar MOT para <sup>*</sup></Label>
                                <Select
                                    simpleValue cacheAsyncResults={false} options={empregadoOptions} value={this.controller.itemSelecionado.matriculas}
                                    onChange={(value) => this.controller.setGestoresPermitidos(value)}
                                    searchPromptText="Pesquise pela matrícula"
                                    noResultsText={"Empregado não encontrado ou já associado"}
                                    placeholder="Selecione..."
                                    asyncOptions={(input, callback) => this.controller.filtrarGestores(input, callback)}
                                    multi
                                />
                            </FormGroup>
                        </Col>
                    }
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilRelatorioSISMOT} onChange={() => this.controller.togglePerfilRelatorioSISMOT()} />{' '}
                                <Label>Relatório MOTs para Seguro</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilRelatorioFinanceiro} onChange={() => this.controller.togglePerfilRelatorioFinanceiro()}/>{' '}
                                <Label>Relatório financeiro</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={5} lg={5}>
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilRelatorioTimesheet} onChange={() => this.controller.togglePerfilRelatorioTimesheet()}/>{' '}
                                <Label>Timesheets pendentes</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.perfilRelatorioMOTsAtivas} onChange={() => this.controller.togglePerfilRelatorioMOTsAtivas()}/>{' '}
                                <Label>Relatório MOTs ativas</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                    {this.controller.itemSelecionado.perfilRelatorioTimesheet &&
                        <Col xs={12} md={7} lg={7}>
                            <div className="inline-checkbox">
                                <div style={{ paddingRight: "20px" }}>
                                    <FormGroup>
                                        <Label>Notificações: </Label>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingRight: "20px" }}>
                                    <FormGroup check >
                                        <Label check>
                                            <Input type="checkbox" checked={this.controller.itemSelecionado.notificacaoTimesheetD3} onChange={() => this.controller.toggleNotificacaoTimesheetD3()}/>{' '}
                                            <Label>D-3</Label>
                                        </Label>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingRight: "20px" }}>
                                    <FormGroup check >
                                        <Label check>
                                            <Input type="checkbox" checked={this.controller.itemSelecionado.notificacaoTimesheetD2} onChange={() => this.controller.toggleNotificacaoTimesheetD2()}/>{' '}
                                            <Label>D-2</Label>
                                        </Label>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingRight: "20px" }}>
                                    <FormGroup check >
                                        <Label check>
                                            <Input type="checkbox" checked={this.controller.itemSelecionado.notificacaoTimesheetD1} onChange={() => this.controller.toggleNotificacaoTimesheetD1()}/>{' '}
                                            <Label>D-1</Label>
                                        </Label>
                                    </FormGroup>
                                </div>
                            </div>
                        </Col>
                    }
                    {(this.controller.itemSelecionado.perfilRelatorioFinanceiro || this.controller.itemSelecionado.perfilRelatorioTimesheet || this.controller.itemSelecionado.perfilRelatorioMOTsAtivas) &&
                        <Col xs={12} md={12} lg={12}>
                            <FormGroup>
                                <Label>Possui acesso às posições abaixo de: </Label>
                                <Select searchPromptText="Informe CPF ou matrícula para pesquisar"
                                    noResultsText={"Empregado não encontrado ou já associado"}
                                    placeholder="Selecione..."
                                    value={this.controller.itemSelecionado.empregadoCPFs}
                                    onChange={(value) => this.controller.setEmpregadoByMatricula(value)}
                                    options = {this.controller.posicoesSelecionadas}
                                    asyncOptions={(input, callback) => this.controller.filtrarEmpregadosByMatricula(input, callback)} multi/>
                                {(this.controller.itemSelecionado.perfilRelatorioFinanceiro || this.controller.itemSelecionado.perfilRelatorioTimesheet || this.controller.itemSelecionado.perfilRelatorioMOTsAtivas) &&
                                    <Validacao id="posicoes" valor={this.controller.posicoesSelecionadas} tipo={["isArrayNotEmpty"]}/>
                                }
                            </FormGroup>
                        </Col>
                    }
                    {(this.controller.itemSelecionado.perfilRelatorioFinanceiro || this.controller.itemSelecionado.perfilRelatorioTimesheet || this.controller.itemSelecionado.perfilRelatorioMOTsAtivas) && this.controller.posicoesSelecionadas &&
                        <Col xs={12} md={12} lg={12}>
                            {
                                this.controller.posicoesSelecionadas.map(
                                    (posicao, i) =>
                                        <FormGroup Key={i}>
                                            <div>
                                                <div className="history-item" style={{width: "85%", float: "left"}}>
                                                    {posicao}
                                                </div>
                                                <div style={{float: "left", marginLeft: "10px", marginTop: "3px" }} onClick={() => this.removePosicao(posicao)}><FontAwesome name="minus-circle" size="2x"/></div>
                                            </div>
                                        </FormGroup>
                                )
                            }
                        </Col>
                    }
                </Row>
            </div>
        )
    };

    obterTituloMobile = (objeto) => {
        return getTipoPerfilById(objeto.tipo).valor;
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "Membros: " + arrayToString(objeto.usuarios,"nome")}<br/>
            </div>
        )
    };

    perfisFormat(cell, row) {
        let perfis = [];
        if(row) {
            if(row.perfilAdministrador) {
                perfis.push("Administrador");
            }
            if(row.perfilDcch) {
                perfis.push("DCCH");
            }
            if(row.perfilDnc) {
                perfis.push("DNC");
            }
            if(row.perfilRecurso) {
                perfis.push("Recurso");
            }
            if(row.perfilRemuneracao) {
                perfis.push("Remuneração");
            }
            if(row.perfilRts) {
                perfis.push("RTS");
            }
            if(row.perfilSolicitanteMot) {
                perfis.push("Solicitante de MOT");
            }
            if(row.perfilRelatorioFinanceiro) {
                perfis.push("Relatório financeiro");
            }
            if(row.perfilRelatorioTimesheet) {
                perfis.push("Relatório timesheets pendentes");
            }
            if(row.perfilRelatorioMOTsAtivas) {
                perfis.push("Relatório MOTs ativas");
            }
            //RHFPP-612 - Relatório SIS MOT
            if (row.perfilRelatorioSISMOT) {
                perfis.push("Relatório MOTs p/ Seguro");
            }

        }

        return perfis.join(", ");
    }

    solicitantesMotUsuarioFormat(cell, row) {
        return arrayToString(row.solicitantesMotUsuario,"nome");
    }

    render() {
        /* Colunas da TabelaStore */
        const colunas = [
            {
                field: "nome",
                label: "Usuário"
            },{
                label: "Perfis",
                dataFormat: this.perfisFormat
            }, {
                label: "Pode solicitar MOT para",
                dataFormat: this.solicitantesMotUsuarioFormat
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'Usuário'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.usuarioLista}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={true}
                            modalEditar={this.modalForm(true)}
                            modalCadastrar={this.modalForm(false)}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            cadastrar={() => this.controller.cadastrar()}
                            remover={() => this.controller.remover()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}